module.exports = __webpack_public_path__ + "static/img/gggggg_02.44138ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_02.png
// module id = mOtE
// module chunks = 1